"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const user_info_1 = __importDefault(require("../user-info/user-info"));
const license_info_1 = __importDefault(require("../license-info/license-info"));
const contact_info_1 = __importDefault(require("../contact-info/contact-info"));
require("./view.scss");
const react_redux_1 = require("react-redux");
class ProfileView extends react_1.Component {
    render() {
        const { guest, user, className } = this.props;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("div", { id: 'attorney-profile-container', className: className },
                react_1.default.createElement("div", { className: "profile-content" },
                    react_1.default.createElement(core_1.Grid, { container: true, className: "d-flex justify-content-between" },
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 4, className: "user-info-grid d-flex" },
                            react_1.default.createElement(user_info_1.default, { guest: guest })),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 8, className: "case-info" },
                            user.roleId !== 9 && react_1.default.createElement(license_info_1.default, { guest: guest }),
                            react_1.default.createElement(contact_info_1.default, { guest: guest })))))));
    }
}
const mapStateToProps = (state) => {
    const { user } = state;
    return {
        user
    };
};
exports.default = react_redux_1.connect(mapStateToProps, null)(ProfileView);
